<template lang="pug">
    .container-fluid
      h1 Faculty Work Assignment Template (WAT)
      .row
        ul
          h4 List of Reports
          span Last Updated: Dec 2023
          hr
          ul.col.py-2
            li
              ExternalLink.link.hand(href="https://www.hawaii.edu/iro/pdfs/bor/Faculty%20Workload%20from%20BOR_01_07_2021_Materials.pdf") Academic Year 2019-2020
              |  [ as presented to the BOR Committee on Academic and Student Affairs ]
            li
              ExternalLink.link.hand(href="https://www.hawaii.edu/iro/pdfs/bor/Faculty Workload from BOR_2_17_2022_Materials.pdf") Academic Year 2020-2021
              |  [ as presented to the Full Board of Regents ]
            li
              ExternalLink.link.hand(href="https://www.hawaii.edu/iro/pdfs/bor/Faculty%20Workload%20from%20BOR_02_16_2023_Materials.pdf") Academic Year 2021-2022
              |  [ as presented to the Full Board of Regents ]
</template>

<script>
import { mapGetters } from 'vuex';
import ExternalLink from '@components/ExternalLink';

export default {
  name: 'FacultyWorkloadAssignmentTemplate',
  components: {
    ExternalLink
  },
  props: {
    msg: String
  },
  computed: {
    ...mapGetters('content', [
      'environment'
    ]),
    ...mapGetters('session', [
      'session',
      'sessionDisplayIsDark',
      'sessionGetDisplayClass',
      'sessionFullName',
      'sessionHasToken',
      'sessionIsFacultyStaff'
    ]),
  },
  methods: {
  }
}


</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="stylus" scoped>
  .hand
    cursor pointer
</style>
